import useMedia from "utils/hooks/useMedia.ts";
import { MOBILE_SEARCH } from "common/constants.ts";
import { useDisablePageScroll } from "utils/hooks/misc.tsx";
import { sharedLib } from "@shared/services/shared.service.ts";
import { LanguageNameSpaces, PayoutMethodSource } from "@shared/types";
import { useState } from "react";
import { openMessage } from "utils/misc.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { useSubUserPermissions } from "@shared/utils/hooks/misc.ts";

const useInvoices = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PAYOUTS);
  const { isSubUser } = useSubUserPermissions();
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const isSmallScreen = useMedia([`(max-width: 1500px)`], [true], false);
  useDisablePageScroll(isMobile);

  const { isLoading: clientsLoading } =
    sharedLib.sharedApi.configuration.useGetClientsListQuery(undefined);
  const {
    data: invoices,
    isLoading: invoicesLoading,
    isFetching: invoicesFetching,
    refetch: invoicesRefetch,
  } = sharedLib.sharedApi.settings.useGetAssetManagerInvoicesQuery();
  const {
    data: paymentMethods,
    isLoading: payoutMethodsLoading,
    isFetching: payoutMethodsFetching,
    refetch: payoutMethodsRefetch,
  } = sharedLib.sharedApi.settings.useGetPayoutMethodsQuery(
    {
      source: PayoutMethodSource.INVOICE,
    },
    { skip: isSubUser }
  );

  const [openCreateInvoiceModal, setOpenCreateInvoiceModal] = useState(false);
  const [openPayoutMethodsModal, setOpenPayoutMethodsModal] = useState(false);

  const loading =
    invoicesLoading || (!isSubUser && payoutMethodsLoading) || clientsLoading;

  const refetch = () => {
    invoicesRefetch();
    if (!isSubUser) payoutMethodsRefetch();
  };

  const onCreateInvoiceClick = () => {
    if (paymentMethods?.length) setOpenCreateInvoiceModal(true);
    else {
      openMessage(
        t("invoices.create_invoice_modal.errors.create_payment_method_first"),
        "warning"
      );
    }
  };

  return {
    isMobile,
    isSubUser,
    isSmallScreen,
    loading,
    clientsLoading,
    payoutMethodsFetching,
    invoices,
    invoicesFetching,
    refetch,
    payoutMethodsRefetch,
    paymentMethods,
    openCreateInvoiceModal,
    setOpenCreateInvoiceModal,
    openPayoutMethodsModal,
    setOpenPayoutMethodsModal,
    onCreateInvoiceClick,
  };
};

export default useInvoices;
